import { styled } from '@mui/material/styles';

export const RdContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const FilterBuffer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const DataContainer = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
}));

export const PadLeft = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));

export const RdRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  fontSize: 14,

  '& span': {
    marginLeft: 3,

    '&.bold': {
      fontWeight: 'bold',
    },
  },
});

export const ButtonContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hidePrint',
})(({ theme, hidePrint }) => ({
  marginTop: theme.spacing(2),
  ...(hidePrint && {
    '@media print': {
      display: 'none',
    },
  }),
}));

export const BtnCol = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ColTitle = styled('div')({
  fontSize: 14,
});

export const BtnRow = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),

  '& button': {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));
